export const FEEDBACK_LABEL = "Hva kan vi forbedre?";
export const ERROR_MESSAGE = "Feil ved sending, prøv igjen senere";
